import {put,takeLatest,call} from 'redux-saga/effects';
import * as imageService from "../../../services/imageService";
import {
    GET_IMAGES,
    GET_IMAGES_SUCCESS,
    GET_IMAGES_ERROR
}
    from "../../actions/image";

function* getImagesSaga(action) {
    try {
        const data=yield call(imageService.GetImages,action.payload)
        yield put({
            type: GET_IMAGES_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: GET_IMAGES_ERROR,error: error.data
        });
    }
}

export function* getImagesSagaWatcher() {
    yield takeLatest(GET_IMAGES,getImagesSaga);
}